import { render, staticRenderFns } from "./STooltipX.vue?vue&type=template&id=31bf38c8&scoped=true&"
import script from "./STooltipX.vue?vue&type=script&lang=js&"
export * from "./STooltipX.vue?vue&type=script&lang=js&"
import style0 from "./STooltipX.vue?vue&type=style&index=0&id=31bf38c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bf38c8",
  null
  
)

export default component.exports